import { useEffect } from 'react';

const PAYPAL_BUTTONS = [
  { name: 'Single Use',  id: 'TX3PQB9MQ5ZWW' },
  { name: 'Dual Use',   id: '7R8U5PTHWRB8W' },
  { name: 'Quad Use',   id: 'YXB457S6SH458' },
  { name: 'Multi Use',  id: 'DJGJDF8U6A7J6' },
];

const PricingSection = () => {
  const plans = [
    {
      name: 'Single Use',
      price: '$9.99',
      period: 'one time',
      features: [
        'One domain',
        'Single use license key',
        'Full SEO Analysis and Reporting',
        '',
        '',
      ],
      bgColor: 'bg-gray-50',
      featured: false,
    },
    {
      name: 'Dual Use',
      price: '$18.99',
      period: '2 reports',
      features: [
        'Up to 2 domains',
        'Multi use license key',
        'Can be used in multiple sessions',
        'Full SEO Analysis and Reporting',
      ],
      bgColor: 'bg-amber-50',
      featured: false,
    },
    {
      name: 'Quad Use',
      price: '$34.99',
      period: '4 reports',
      features: [
        'Up to 4 domains',
        'Multi use license key',
        'Can be used in multiple sessions',
        'Full SEO Analysis and Reporting',
      ],
      bgColor: 'bg-violet-50',
      featured: true,
    },
    {
      name: 'Multi Use',
      price: '$89.99',
      period: '10 reports',
      features: [
        'Up to 10 domains',
        'Multi use license key',
        'Can be used in multiple sessions',
        'Full SEO Analysis and Reporting',
      ],
      bgColor: 'bg-green-50',
      featured: false,
      bestValue: true,
    },
  ];

  useEffect(() => {
    const tryRender = () => {
      const paypal = (window as any).paypal;
      if (!paypal?.HostedButtons) return false;

      PAYPAL_BUTTONS.forEach(({ id }) => {
        const containerId = `paypal-container-${id}`;
        const el = document.getElementById(containerId);
        if (el && el.childElementCount === 0) {
          try {
            paypal.HostedButtons({ hostedButtonId: id }).render(`#${containerId}`);
          } catch {
            // already rendered or not ready yet
          }
        }
      });
      return true;
    };

    if (!tryRender()) {
      // PayPal SDK not loaded yet — poll until it is
      const interval = setInterval(() => {
        if (tryRender()) clearInterval(interval);
      }, 300);
      return () => clearInterval(interval);
    }
  }, []);

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
          {plans.map((plan, index) => (
            <div
              key={index}
              className={`${plan.bgColor} rounded-3xl p-8 ${
                plan.featured ? 'scale-105 relative' : 'relative'
              } transition-all duration-300 hover:shadow-2xl shadow-lg`}
            >
              {plan.featured && (
                <div className="absolute -top-4 left-1/2 -translate-x-1/2 px-4 py-1 bg-[#FF6B35] text-white text-sm font-bold rounded-full whitespace-nowrap">
                  MOST POPULAR
                </div>
              )}
              {(plan as any).bestValue && (
                <div className="absolute -top-4 left-1/2 -translate-x-1/2 px-4 py-1 bg-green-700 text-white text-sm font-bold rounded-full whitespace-nowrap">
                  BEST VALUE
                </div>
              )}

              <h3 className="text-2xl font-bold mb-2 text-gray-900">{plan.name}</h3>

              <div className="mb-4">
                <span className="text-4xl font-extrabold text-gray-900">{plan.price}</span>
                <span className="text-gray-500 ml-2 text-sm">/ {plan.period}</span>
              </div>

              <ul className="space-y-2 mb-6">
                {plan.features.map((feature, i) => (
                  <li key={i} className="flex items-start gap-2 text-gray-700 text-sm">
                    {feature ? (
                      <>
                        <i className="ri-check-line text-[#4f3af6] mt-0.5 flex-shrink-0"></i>
                        <span>{feature}</span>
                      </>
                    ) : (
                      <span className="block h-5" />
                    )}
                  </li>
                ))}
              </ul>

              <div id={`paypal-container-${PAYPAL_BUTTONS.find(b => b.name === plan.name)?.id}`} className="min-h-[50px]" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PricingSection;
